export default "__VITE_ASSET__CUjpVhY3__"